import React from 'react';
import ReactDOM from 'react-dom';
import { useState, useEffect, useRef } from 'react';

function useOutsideAlerter(triggerRef, menuRef, dropped, setDropped) {
	useEffect(() => {
		if (!dropped) return;
		function handleClickOutside(event) {
			const inTrigger = triggerRef.current && triggerRef.current.contains(event.target);
			const inMenu = menuRef.current && menuRef.current.contains(event.target);
			if (!inTrigger && !inMenu) setDropped(false);
		}
		document.addEventListener('mousedown', handleClickOutside);
		return () => document.removeEventListener('mousedown', handleClickOutside);
	}, [dropped, triggerRef, menuRef]);
}

export default ({ children, className, icon, title, position = 'left', ...rest }) => {
	const [dropped, setDrop] = useState(false);
	const [menuStyle, setMenuStyle] = useState({});
	const triggerRef = useRef(null);
	const menuRef = useRef(null);

	useOutsideAlerter(triggerRef, menuRef, dropped, setDrop);

	useEffect(() => {
		if (!dropped || !triggerRef.current) return;
		const updatePosition = () => {
			if (!triggerRef.current) return;
			const rect = triggerRef.current.getBoundingClientRect();
			setMenuStyle({
				position: 'fixed',
				top: rect.bottom + 8,
				right: window.innerWidth - rect.right,
			});
		};
		const closeOnScroll = () => setDrop(false);
		updatePosition();
		window.addEventListener('scroll', closeOnScroll, true);
		window.addEventListener('resize', updatePosition);
		return () => {
			window.removeEventListener('scroll', closeOnScroll, true);
			window.removeEventListener('resize', updatePosition);
		};
	}, [dropped]);

	return (
		<>
			<div
				ref={triggerRef}
				className={`dropdown custom-dropdown ${className} ${dropped ? 'active' : ''}`}
				onClick={() => setDrop(!dropped)}
			>
				<span className="dropdown-trigger">
					<i className={`${icon} m-0`} />
					<span className="dropdown-title">{title}</span>
					<i className="icon-chevron-down" />
				</span>
			</div>
			{dropped && ReactDOM.createPortal(
				<div ref={menuRef} className="dropdown-menu-portal menu right-0" style={menuStyle}>
					{children}
				</div>,
				document.body
			)}
		</>
	);
};
